import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography, Menu, MenuItem, Tooltip } from "@mui/material";
import { ChevronLeft, ChevronRight, Dashboard, ExpandMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import userIcon from "../../../static/media/icon/user.svg";
import briefcaseIcon from "../../../static/media/icon/briefcase.svg";

const getCSRFTokenFromCookie = () => {
  const name = "csrftoken";
  const cookies = document.cookie.split(";");
  for (let c of cookies) {
    const t = c.trim();
    if (t.startsWith(name + "=")) return decodeURIComponent(t.substring(name.length + 1));
  }
  return "";
};

const fetchCsrfToken = async () => {
  const fromCookie = getCSRFTokenFromCookie();
  if (fromCookie) return fromCookie;

  try {
    const r = await fetch("/sistema/get-csrf-token/", { method: "GET", credentials: "include" });
    const d = await r.json().catch(() => ({}));
    return d?.csrfToken || d?.csrf || d?.token || "";
  } catch {
    return "";
  }
};

const TopBar = ({ open, setOpen }) => {
  const [email, setEmail] = useState(localStorage.getItem("user_email") || "");
  const [role, setRole] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const s = localStorage.getItem("is_superuser") === "true";
    const a = localStorage.getItem("is_admin") === "true";
    const v = localStorage.getItem("is_vendedor") === "true";

    if (s) {
      setRole("SUPERUSUARIO");
      setIsAdmin(true);
    } else if (a) {
      setRole("ADMINISTRADOR");
      setIsAdmin(true);
    } else if (v) {
      setRole("VENDEDOR");
      setIsAdmin(false);
    } else {
      setRole("");
      setIsAdmin(false);
    }

    if (!email) {
      const fetchUser = async () => {
        try {
          const csrf = await fetchCsrfToken();
          const res = await fetch("/sistema/get_user_info/", {
            method: "GET",
            credentials: "include",
            headers: csrf ? { "X-CSRFToken": csrf } : {},
          });
          if (res.ok) {
            const data = await res.json();
            if (data?.email) {
              localStorage.setItem("user_email", data.email);
              setEmail(data.email);
            }

            const ss = !!data?.is_superuser;
            const aa = !!data?.is_admin;
            const vv = !!data?.is_vendedor;

            if (ss) {
              setRole("SUPERUSUARIO");
              setIsAdmin(true);
            } else if (aa) {
              setRole("ADMINISTRADOR");
              setIsAdmin(true);
            } else if (vv) {
              setRole("VENDEDOR");
              setIsAdmin(false);
            }

            localStorage.setItem("is_superuser", String(ss));
            localStorage.setItem("is_admin", String(aa));
            localStorage.setItem("is_vendedor", String(vv));
          }
        } catch {}
      };
      fetchUser();
    }
  }, [email]);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    try {
      const csrf = await fetchCsrfToken();
      await fetch("/sistema/logout/", {
        method: "POST",
        credentials: "include",
        headers: csrf ? { "X-CSRFToken": csrf } : {},
      });
    } catch {}

    localStorage.removeItem("user_email");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("is_vendedor");
    localStorage.removeItem("is_logged_in");
    navigate("/");
  };

  return (
    <Box
      sx={{
        width: "95%",
        mx: "auto",
        mt: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#fafafa",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? (
            <ChevronLeft sx={{ fontSize: 30, color: "black" }} />
          ) : (
            <ChevronRight sx={{ fontSize: 30, color: "black" }} />
          )}
        </IconButton>

        <IconButton onClick={() => navigate("/admin-panel")}>
          <Dashboard sx={{ fontSize: 30, color: "black" }} />
        </IconButton>

        <Typography sx={{ fontSize: "0.95rem", fontWeight: 600, ml: 1, color: "#444" }}>
          {role} - CMSOLTEC
        </Typography>

      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {isAdmin && (
          <Tooltip title="Mi Compañía" arrow>
            <Box
              onClick={() => navigate("/admin-panel/empresa")}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                p: "4px 6px",
                borderRadius: "6px",
              }}
            >
              <img
                src={briefcaseIcon}
                alt="Compañía"
                style={{
                  width: 30,
                  height: 30,
                  objectFit: "contain",
                }}
              />
            </Box>
          </Tooltip>
        )}

        <Box
          onClick={handleMenuOpen}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
            userSelect: "none",
            p: "4px 8px",
            borderRadius: "6px",
          }}
        >
          <img
            src={userIcon}
            alt="Usuario"
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <Typography
            sx={{
              fontSize: "0.95rem",
              fontWeight: 500,
              color: "#1565C0",
              letterSpacing: 0.3,
            }}
          >
            {email || "—"}
          </Typography>
          <ExpandMore sx={{ color: "#1565C0", fontSize: 22 }} />
        </Box>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: 2,
            boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
          },
        }}
      >
        <MenuItem onClick={handleMenuClose}>Mi perfil</MenuItem>
        <MenuItem onClick={handleMenuClose}>Mi cuenta</MenuItem>
        <MenuItem onClick={handleLogout}>Cerrar Sesión</MenuItem>
      </Menu>
    </Box>
  );
};

export default TopBar;
